<div class="soft-card h-full">
 <div class="flex flex-col pb-2 border-b">
   <span class="text-sm font-normal text-light">{{ lagerliste().artikel?.artikelnummer }}</span>
   <h6 class="text-base font-semibold">{{ lagerliste().artikel?.bezeichnung }}</h6>
 </div>

  <div class="flex flex-shrink-0 whitespace-nowrap items-center overflow-x-auto">
    <soft-tab-group [activatedIndex]="tabIndex()" (activatedIndexChange)="tabIndex.set($event)">
      @for (lagerstand of lagerliste().lagerstaende; track $index) {
        <soft-tab [title]="$safeNavigationMigration(lagerstand?.lagerstamm?.bezeichnung)"></soft-tab>
      }
    </soft-tab-group>
  </div>

  <ul>
    <li class="soft-overline mt-3">{{ selectedLager()?.lagerstamm?.bezeichnung }}</li>
    <li class="flex items-center justify-between w-full py-2 border-b">
      <span class="text-sm">Fetteinheiten</span>
      <span class="text-sm">{{ (selectedLager()?.werte?.fetteinheiten ?? 0) | number:'1.3-3' }}</span>
    </li>
    <li class="flex items-center justify-between w-full py-2 border-b">
      <span class="text-sm">Fetteinheiten %</span>
      <span class="text-sm">{{ (selectedLager()?.werte?.fetteinheitenProz ?? 0) | number:'1.3-3' }}</span>
    </li>
    <li class="flex items-center justify-between w-full py-2 border-b">
      <span class="text-sm">Eiweisseinheiten</span>
      <span class="text-sm">{{ (selectedLager()?.werte?.eiweisseinheiten ?? 0) | number:'1.3-3' }}</span>
    </li>
    <li class="flex items-center justify-between w-full py-2 border-b">
      <span class="text-sm">Eiweisseinheiten %</span>
      <span class="text-sm">{{ (selectedLager()?.werte?.eiweisseinheitenProz ?? 0) | number:'1.3-3' }}</span>
    </li>
    <li class="flex items-center justify-between w-full py-2 border-b">
      <span class="text-sm">Gewicht</span>
      <span class="text-sm">{{ (selectedLager()?.werte?.gewicht ?? 0) | number:'1.3-3' }}</span>
    </li>
    <li class="flex items-center justify-between w-full py-2">
      <span class="text-sm">Menge</span>
      <span class="text-sm">{{ (selectedLager()?.werte?.menge ?? 0) | number:'1.3-3' }}</span>
    </li>
  </ul>

  <!--<ul class="max-h-[250px] overflow-y-auto">
    @for (lagerstand of lagerliste().lagerstaende; track $index) {
      <li class="soft-overline mt-3">{{ lagerstand?.lagerstamm?.bezeichnung }}</li>
      <li class="flex items-center justify-between w-full py-2 border-b">
        <span class="text-sm">Fetteinheiten</span>
        <span class="text-sm">{{ (lagerstand?.werte?.fetteinheiten ?? 0) | number:'1.3-3' }}</span>
      </li>
      <li class="flex items-center justify-between w-full py-2 border-b">
        <span class="text-sm">Fetteinheiten %</span>
        <span class="text-sm">{{ (lagerstand?.werte?.fetteinheitenProz ?? 0) | number:'1.3-3' }}</span>
      </li>
      <li class="flex items-center justify-between w-full py-2 border-b">
        <span class="text-sm">Eiweisseinheiten</span>
        <span class="text-sm">{{ (lagerstand?.werte?.fetteinheiten ?? 0) | number:'1.3-3' }}</span>
      </li>
      <li class="flex items-center justify-between w-full py-2 border-b">
        <span class="text-sm">Eiweisseinheiten %</span>
        <span class="text-sm">{{ (lagerstand?.werte?.fetteinheitenProz ?? 0) | number:'1.3-3' }}</span>
      </li>
      <li class="flex items-center justify-between w-full py-2 border-b">
        <span class="text-sm">Gewicht</span>
        <span class="text-sm">{{ (lagerstand?.werte?.gewicht ?? 0) | number:'1.3-3' }}</span>
      </li>
      <li class="flex items-center justify-between w-full py-2 border-b">
        <span class="text-sm">Menge</span>
        <span class="text-sm">{{ (lagerstand?.werte?.menge ?? 0) | number:'1.3-3' }}</span>
      </li>
    }
  </ul>
  -->
</div>
